


























































































































































































import SearchBuilder from "@/builder/SearchBuilder";
import ContractPreviewModal from "@/components/ContractUploader/ContractPreviewModal.vue";
import ContractUploadModal from "@/components/ContractUploader/ContractUploadModal.vue";
import SelectBranch from "@/components/custom/select/SelectBranch.vue";
import SelectCustomer from "@/components/custom/select/SelectCustomer.vue";
import { debounceProcess } from "@/helpers/debounce";
import useBlob from "@/hooks/useBlob";
import useDate from "@/hooks/useDate";
import MNotificationVue from "@/mixins/MNotification.vue";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { ContractUploaderListDto } from "@/models/interface/contract-uploader/ContractUploaderListDto.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { InternalContractListDto } from "@/models/interface/internal-contract";
import { contractUploaderService } from "@/services/ContractUploader.service";
import { internalContractService } from "@/services/InternalContract.service";
import moment from "moment";
import { Component, Mixins } from "vue-property-decorator";

interface ContractUploaderFilters {
  branch: string | undefined;
  customerId: string | undefined;
  documentNo: string | undefined;
  hasAttachment: string;
  contractDate: (moment.Moment | null)[] | [];
}

interface PaginationChange {
  current: number;
  pageSize: number;
}

@Component({
  components: {
    SelectBranch,
    SelectCustomer,
    ContractPreviewModal,
    ContractUploadModal,
  },
})
export default class ContractUploaderListPage extends Mixins(MNotificationVue) {
  filters: ContractUploaderFilters = {
    branch: undefined,
    customerId: undefined,
    documentNo: undefined,
    hasAttachment: "",
    contractDate: [],
  };

  moment = moment;
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  toStartDay = useDate().toStartDay;
  toEndDay = useDate().toEndDay;

  // Preview modal state
  preview = {
    visible: false,
    record: null as ContractUploaderListDto | null,
  };

  // Upload modal state
  upload = {
    visible: false,
    record: null as ContractUploaderListDto | null,
  };

  dataSource: ContractUploaderListDto[] = [];
  dataListInternalContractNo: InternalContractListDto[] = [];
  getListInternalContractNo: (valueSearch: string) => void =
    this._getListInternalContractNo;
  totalElements = 0;
  loading = {
    table: false,
    documentNo: false,
  };
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
  };

  get columns() {
    return [
      {
        title: this.$t("lbl_ic_number"),
        dataIndex: "documentNo",
        scopedSlots: { customRender: "documentNo" },
        width: 150,
      },
      {
        title: this.$t("lbl_contract_date"),
        dataIndex: "contractDate",
        width: 150,
      },
      { title: this.$t("lbl_branch"), dataIndex: "branchName", width: 150 },
      { title: this.$t("lbl_pic"), dataIndex: "picName", width: 150 },
      {
        title: this.$t("lbl_customer_name"),
        dataIndex: "customerName",
        width: 200,
      },
      {
        title: this.$t("lbl_rent_period"),
        dataIndex: "rentPeriod",
        width: 220,
      },
      {
        title: this.$t("lbl_attachment"),
        dataIndex: "hasAttachment",
        scopedSlots: { customRender: "hasAttachment" },
        width: 120,
        align: "center" as const,
      },
      {
        title: this.$t("lbl_action"),
        scopedSlots: { customRender: "actions" },
        width: 150,
        align: "center" as const,
      },
    ];
  }

  get paginationConfig() {
    return {
      ...this.pagination,
      showTotal: (total: number) => this.$t("lbl_total_items", { total }),
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    };
  }

  handleFind() {
    this.pagination.current = 1;
    this.fetchList();
  }

  handleReset() {
    this.filters = {
      branch: undefined,
      customerId: undefined,
      documentNo: undefined,
      hasAttachment: "",
      contractDate: [],
    };
    (this.$refs.filterForm as any).resetFields();
    this.pagination.current = 1;
    this.dataSource = [];
    this.totalElements = 0;
  }

  handleTableChange(pag: PaginationChange): void {
    this.pagination.current = pag.current;
    this.pagination.pageSize = pag.pageSize;
    this.fetchList();
  }

  handleDownload(record: ContractUploaderListDto): void {
    if (record.fileContract == null) return;

    const fileContract = record.fileContract;
    const fileName = fileContract.split("/").pop();

    if (!fileName) return;

    contractUploaderService
      .getFile(fileContract)
      .then(blob => {
        const { toDownload } = useBlob();
        toDownload(blob, fileName);
      })
      .catch(() => {
        this.showNotifError("notif_error_status_code");
      });
  }

  openPreviewModal(record: ContractUploaderListDto): void {
    this.preview.record = record;
    this.preview.visible = true;
  }

  openUploadModal(record: ContractUploaderListDto): void {
    this.upload.record = record;
    this.upload.visible = true;
  }

  closePreviewModal(): void {
    this.preview.visible = false;
    this.preview.record = null;
  }

  closeUploadModal(): void {
    this.upload.visible = false;
    this.upload.record = null;
  }

  handleUploadSuccess(): void {
    this.fetchList();
  }

  onRangePickerChange(dates: (moment.Moment | null)[]): void {
    if (!dates || !dates.length || dates[0] === null) {
      this.filters.contractDate = [];
    }
  }

  created(): void {
    this.getListInternalContractNo = debounceProcess(
      this._getListInternalContractNo.bind(this),
      200
    );
    this.getListInternalContractNo("");
  }

  _getListInternalContractNo(valueSearch: string): void {
    const params: RequestQueryParamsModel = {
      limit: 10,
      page: 0,
    };
    if (valueSearch) {
      const builder = new SearchBuilder();
      params.search = builder
        .push(["documentNo", valueSearch], { like: "both" })
        .build();
    }
    this.loading.documentNo = true;
    internalContractService
      .list(params)
      .then(response => {
        this.dataListInternalContractNo = response.data;
      })
      .catch(() => {
        this.showNotifError("notif_error_status_code");
      })
      .finally(() => {
        this.loading.documentNo = false;
      });
  }

  buildSearchParams(filters: ContractUploaderFilters): string {
    const builder = new SearchBuilder();

    if (filters.branch) {
      builder.push(["branch.secureId", filters.branch]);
      builder.and();
    }
    if (filters.customerId) {
      builder.push(["customer.secureId", filters.customerId]);
      builder.and();
    }
    if (filters.documentNo) {
      builder.push(["documentNo", filters.documentNo]);
      builder.and();
    }
    if (filters.contractDate && filters.contractDate.length === 2) {
      const startDate = filters.contractDate[0];
      const endDate = filters.contractDate[1];

      if (startDate && endDate) {
        const startMoment = moment.isMoment(startDate)
          ? startDate
          : moment(startDate);
        const endMoment = moment.isMoment(endDate) ? endDate : moment(endDate);

        if (startMoment.isValid() && endMoment.isValid()) {
          const fromDate = this.toStartDay(startMoment).format();
          const toDate = this.toEndDay(endMoment).format();
          builder.push(["contractDate", fromDate], { het: true });
          builder.and();
          builder.push(["contractDate", toDate], { let: true });
        }
      }
    }

    return builder.build();
  }

  async fetchList(): Promise<void> {
    this.loading.table = true;
    try {
      const params: RequestQueryParamsModel = {
        page: this.pagination.current - 1,
        limit: this.pagination.pageSize,
        sorts: "contractDate:DESC",
      };

      if (this.filters.hasAttachment)
        params.hasAttachment = this.filters.hasAttachment;

      const searchParams = this.buildSearchParams(this.filters);
      if (searchParams) {
        params.search = searchParams;
      }

      const response = await internalContractService.list(params);

      this.dataSource = response.data.map(item => ({
        ...item,
        hasAttachment: !!item.fileContract,
      }));

      this.pagination.total = response.totalElements;
      this.totalElements = response.totalElements;
    } catch (error) {
      this.showNotifError("notif_error_status_code");
    } finally {
      this.loading.table = false;
    }
  }
}
